import type { ApiClient } from '@church/api-client'
import { createContext, useContext, type ReactNode } from 'react'

/**
 * Makes the Eden client available to every hook in this package.
 *
 * The client is injected rather than constructed here because web and mobile
 * build it differently — cookies vs. SecureStore bearer tokens — while every
 * hook above this line stays identical on both platforms.
 */
const ApiContext = createContext<ApiClient | null>(null)

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext)
  if (!client) throw new Error('useApi must be used inside an <ApiProvider>')
  return client
}
